import { render, staticRenderFns } from "./SimpleNotice.vue?vue&type=template&id=679f744e&"
import script from "./SimpleNotice.vue?vue&type=script&lang=ts&"
export * from "./SimpleNotice.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VSnackbar})
